/** @format */
// 삼육청도연수원 시설 안내 페이지

import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { CommonContext } from '../../contexts';
import './InfoCheongdo.css';

const ADDRESS = '경상북도 청도군 청도읍 양지길 42-15';
const TEL = '054-371-6227';

// 시설별 구성과 이용료(1박 기준)
const FACILITIES = [
  { name: '갈릴리관', price: '130,000원', desc: '방 5개, 거실 2개, 싱크대', use: '소그룹 숙박 및 취사 가능' },
  { name: '다니엘관', price: '100,000원', desc: '방 4개, 거실, 싱크대', use: '객실별 화장실·욕실 완비' },
  { name: '사무엘관', price: '100,000원', desc: '방 4개, 거실, 싱크대', use: '객실별 화장실·욕실 완비' },
  { name: '신관 (기도실)', price: '40,000원', desc: '1층 기도실 14실', use: '개인 기도 공간, 대형 집회 시 숙소 겸용' },
  { name: '대강당', price: '100,000원', desc: '약 100명 수용', use: '대형 집회, 교육, 훈련, 세미나' },
  { name: '소강당', price: '30,000원', desc: '약 30명 수용', use: '소그룹 모임, 세미나, 요가·코칭 프로그램' },
  { name: '전용 식당', note: '식사비 별도', desc: '최대 100명 동시 식사', use: '급식 및 건강식 제공' },
  { name: '야외 운동장', note: '무료 이용', desc: '넓은 야외 공간', use: '야외 훈련, 레크리에이션, 어싱(Earthing) 산책' },
];

const PROGRAMS = [
  ['교회·합회 행사', '목회자협의회, 성도 및 청년 수련회, 패스파인더 교육·훈련, 선교 강습회'],
  ['건강·힐링 캠프', '뉴스타트 힐링캠프, 시니어·실버 건강 캠프, 가정 및 관계 회복 프로그램'],
  ['지역사회 협력', 'ADRA 연계 힐링 프로그램, 공익적 쉼터 제공'],
];

const InfoCheongdo = () => {
  const { categories } = useContext(CommonContext);
  const { pathname } = useLocation();

  const categoryName = categories.find((category) => category.categoryCode === pathname.split('/')[4])?.categoryName;

  return (
    <div id="primary" className="content-area">
      {/* <!--s:#content --> */}
      <div id="content" className="site-content">
        <article>
          <div>
            <div className="title-inner">
              <img src="/common/images/title.png" alt="" />
              <h1>{categoryName ?? '삼육청도연수원 시설 안내'}</h1>
            </div>
            <div style={{ height: 20 }}></div>
            <div style={{ clear: 'both' }}></div>
            <div className="title_subpage_solid_1"></div>
            <div style={{ height: 30 }}></div>

            <div className="cheongdo">
              <p className="cd-oper">운영: 제칠일안식일예수재림교 영남합회</p>

              <img className="cd-hero" src="/common/images/cheongdo.png" alt="삼육청도연수원 본관 전경" />

              <div className="cd-lead">
                <div className="cd-quote">“기도와 말씀, 힐링과 회복이 있는 신앙의 동산”</div>
                <p>
                  삼육청도연수원은 성도들의 헌신적인 기증과 기관들의 후원으로 마련된 영남 지역의 기도와 선교 거점입니다. 아름다운 청도의 자연 속에서 말씀과 기도에 집중하며, 육체적·정서적·영적 회복을
                  경험할 수 있는 다목적 수양 시설입니다.
                </p>
              </div>

              <h2>시설 개요</h2>
              <table className="cd-info">
                <tbody>
                  <tr>
                    <th>시설명</th>
                    <td>삼육청도연수원</td>
                  </tr>
                  <tr>
                    <th>운영 주체</th>
                    <td>제칠일안식일예수재림교 영남합회</td>
                  </tr>
                  <tr>
                    <th>소재지</th>
                    <td>{ADDRESS} (원정리 1017-3)</td>
                  </tr>
                  <tr>
                    <th>수용 규모</th>
                    <td>대형 집회 기준 약 100명 (숙박·급식 동시 수용)</td>
                  </tr>
                  <tr>
                    <th>시설 구성</th>
                    <td>건물 6개 동 및 야외 운동장</td>
                  </tr>
                  <tr>
                    <th>문의 전화</th>
                    <td>
                      <strong>{TEL}</strong>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h2>
                주요 시설 및 이용료 <span className="cd-unit">1박 기준</span>
              </h2>
              <div className="cd-facilities">
                {FACILITIES.map((facility) => (
                  <div className="cd-fac" key={facility.name}>
                    <div className="cd-head">
                      <h3>{facility.name}</h3>
                      <div className="cd-price">{facility.price ?? <small>{facility.note}</small>}</div>
                    </div>
                    <div className="cd-desc">{facility.desc}</div>
                    <div className="cd-use">{facility.use}</div>
                  </div>
                ))}
              </div>

              <div className="cd-meal">
                <b>식사</b> 1식 8,000원 &nbsp;·&nbsp; <b>특별식</b> 10,000원~ (요청 내용에 따라 협의)
              </div>
              <p className="cd-note">※ 이용료는 1박 기준이며, 식사비는 별도입니다.</p>

              <h2>주요 활용 및 프로그램</h2>
              <div className="cd-prog">
                {PROGRAMS.map(([title, detail]) => (
                  <React.Fragment key={title}>
                    <div>{title}</div>
                    <div>{detail}</div>
                  </React.Fragment>
                ))}
              </div>

              <h2>이용 안내</h2>
              <table className="cd-info">
                <tbody>
                  <tr>
                    <th>이용 대상</th>
                    <td>교회·기관 단체, 지역사회 단체 및 개인</td>
                  </tr>
                  <tr>
                    <th>예약 방법</th>
                    <td>
                      전화 예약 — <strong>{TEL}</strong>
                      <br />
                      온라인 예약(웹·모바일 앱)은 준비 중입니다.
                    </td>
                  </tr>
                </tbody>
              </table>

              <h2>오시는 길</h2>
              <iframe
                className="cd-map"
                title="삼육청도연수원 위치"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                src={`https://www.google.com/maps?q=${encodeURIComponent(ADDRESS)}&hl=ko&z=16&output=embed`}
              ></iframe>
              <div className="cd-btns">
                <a href={`https://map.kakao.com/?q=${encodeURIComponent(ADDRESS)}`} target="_blank" rel="noreferrer">
                  카카오맵
                </a>
                <a href={`https://map.naver.com/p/search/${encodeURIComponent(ADDRESS)}`} target="_blank" rel="noreferrer">
                  네이버지도
                </a>
                <a href="tmap://search?name=삼육청도연수원">TMAP 길찾기</a>
              </div>
              <p className="cd-note">
                {ADDRESS} (원정리 1017-3) · 문의 {TEL}
                <br />※ TMAP 길찾기는 모바일에서 앱이 설치된 경우 실행됩니다.
              </p>
            </div>
          </div>
        </article>
      </div>
    </div>
  );
};

export default InfoCheongdo;
